export enum SRT_STATES {
    PENDING = 1,
    GENERATED = 2,
    ERROR = 3,
    CORRECTED = 4
}

export const DEFAULT_VISITS_SRT_STATE_IDS = [
    SRT_STATES.PENDING,
    SRT_STATES.GENERATED
];

export const getVisitsSrtStateIds = (selectedState: any): SRT_STATES[] => {
    const selectedStateId = Number(selectedState?.id ?? selectedState);
    const normalizedState = selectedStateId as SRT_STATES;

    return DEFAULT_VISITS_SRT_STATE_IDS.includes(normalizedState)
        ? [normalizedState]
        : [...DEFAULT_VISITS_SRT_STATE_IDS];
};

export const CLOSED_VISIT_STATE_IDS = [3, 10, 4];

export const SRT_STATES_OPTIONS = Object.entries(SRT_STATES)
    .filter(([_, value]) => typeof value === 'number')
    .map(([key, value]) => ({
        id: value as number,
        nombre: key.toLowerCase()
    }));

